import { CDN_URL } from '../../env'

export const getCdnUrl = (path: string) => `${CDN_URL}/${path}`
